import React from "react";
import "../css/AirportLocationInformation.css";
import tripArrow from "../../../assets/images/trip_arrow.png";
import {
  formatDateTime,
  formatToCustomDate,
  getTimezoneString,
} from "../../../utils/dateUtils";
import { ClearanceStatus, getStatusInfo } from "../../../utils/constants";
import { airportCodeOnApprove, renderAirportCode } from "../../../utils/Utils";

const AirportLocationInformation = ({ tripData, showStatus }) => {
  const departure = formatDateTime(tripData?.departureTime);
  const arrival = formatDateTime(tripData?.arrivalTime);
  const arrivalAirportCode = renderAirportCode(
    tripData?.arrivalAirport?.iataCode,
    tripData?.arrivalAirport?.icaoCode
  );
  const departureFromArrivalAirport = formatDateTime(
    tripData?.departureTimeFromArrivalAirport
  );

  const escortArrivalStatus =
    tripData?.escortArrivalStatus === ClearanceStatus.NOT_REQUIRED
      ? null
      : tripData?.escortArrivalStatus;
  const escortDepartureStatus =
    tripData?.escortDepartureStatus === ClearanceStatus.NOT_REQUIRED
      ? null
      : tripData?.escortDepartureStatus;
  const { text: arrivalStatusText, className: arrivalClassName } =
    getStatusInfo(escortArrivalStatus);
  const { text: departureStatusText, className: departureClassName } =
    getStatusInfo(escortDepartureStatus);

  const clearanceDepartureAfterStatus = tripData?.requiresDepartureOvertime
    ? tripData?.overtimeDepartureStatus
    : null;

  const clearanceArrivalAfterStatus = tripData?.requiresArrivalOvertime
    ? tripData?.overtimeArrivalStatus
    : null;

  const {
    text: departureAfterHoursStatusText,
    className: departureAfterHoursClassName,
  } = getStatusInfo(clearanceDepartureAfterStatus);
  const {
    text: arrivalAfterHoursStatusText,
    className: arrivalAfterHoursClassName,
  } = getStatusInfo(clearanceArrivalAfterStatus);
  return (
    <div className="airport-location-information">
      <p data-testid="airport-location-information-label">Airport Location Information</p>
      <div className="airport-location-information-box">
        <div className="airport-code-details">
          <p className="airport-location-left">
            {renderAirportCode(
              tripData?.departureAirport?.iataCode,
              tripData?.departureAirport?.icaoCode
            )}{" "}
          </p>
          <img
            src={tripArrow}
            className="airport-location-trip-arrow-logo"
            alt="trip arrow"
          />
          <p className="airport-location-right">
            {renderAirportCode(
              tripData?.arrivalAirport?.iataCode,
              tripData?.arrivalAirport?.icaoCode
            )}
          </p>
        </div>

        <div className="airport-location-flight-info">
          <div className="airport-location-departure-info">
            <p>
              Departure
              <span>
                {departure.time} ({getTimezoneString()})
              </span>
            </p>
            <p>
              Date<span>{formatToCustomDate(departure.date)}</span>
            </p>
            <p data-testid="departure-terminal">{tripData?.departureAirportTerminal?.name || "Main Terminal"}</p>
          </div>
          <div className="airport-location-arrival-info">
            <p>
              Arrival
              <span>
                {arrival.time} ({getTimezoneString()})
              </span>
            </p>
            <p>
              Date<span>{formatToCustomDate(arrival.date)}</span>
            </p>
            <p data-testid="arrival-terminal">{tripData?.arrivalAirportTerminal?.name || "Main Terminal"}</p>
          </div>
        </div>

        {tripData?.departureTimeFromArrivalAirport && (
          <div
            className="departure-from-arrival-airport-container"
            data-testid="departure-from-arrival-airport-section"
          >
            <p>
              Departure date and time from the Arrival Airport
              {arrivalAirportCode ? ` - ${arrivalAirportCode}` : ""}
            </p>

            <div className="departure-from-arrival-airport-details">
              <p>
                Date
                <span>
                  {formatToCustomDate(departureFromArrivalAirport.date)}
                </span>
              </p>
              <p>
                Time
                <span>
                  {departureFromArrivalAirport.time} ({getTimezoneString()})
                </span>
              </p>
            </div>
          </div>
        )}

        {showStatus && (
          <div className="status-container">
            {(escortArrivalStatus || escortDepartureStatus) && (
              <p>
                Special Onboarding Screening Status
                {escortDepartureStatus && (
                  <span
                    className={`airport-location-status-${departureClassName}`}
                  >
                    {airportCodeOnApprove(
                      tripData?.departureAirport?.iataCode,
                      tripData?.departureAirport?.icaoCode
                    )}{" "}
                    • {departureStatusText}
                  </span>
                )}
                {escortArrivalStatus && (
                  <span
                    className={`airport-location-status-${arrivalClassName}`}
                  >
                    {airportCodeOnApprove(
                      tripData?.arrivalAirport?.iataCode,
                      tripData?.arrivalAirport?.icaoCode
                    )}{" "}
                    • {arrivalStatusText}
                  </span>
                )}
              </p>
            )}

            {(clearanceDepartureAfterStatus || clearanceArrivalAfterStatus) && (
              <p>
                After Hours Status
                {clearanceDepartureAfterStatus && (
                  <span
                    className={`airport-location-status-${departureAfterHoursClassName}`}
                  >
                    {airportCodeOnApprove(
                      tripData?.departureAirport?.iataCode,
                      tripData?.departureAirport?.icaoCode
                    )}{" "}
                    • {departureAfterHoursStatusText}
                  </span>
                )}
                {clearanceArrivalAfterStatus && (
                  <span
                    className={`airport-location-status-${arrivalAfterHoursClassName}`}
                  >
                    {airportCodeOnApprove(
                      tripData?.arrivalAirport?.iataCode,
                      tripData?.arrivalAirport?.icaoCode
                    )}{" "}
                    • {arrivalAfterHoursStatusText}
                  </span>
                )}
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default AirportLocationInformation;
